<template>
  <div>
    <h2 class="my-1" v-if="$store.getters.hasStarted">Les challenges</h2>
    <h2 class="my-1" v-else>A venir</h2>
    <div class="d-flex flex-column ga-2" v-if="$store.state.loading">
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
    </div>

    <div class="d-flex flex-column ga-2" v-else>
      <v-btn @click="onSelectChallenge('infinity')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == 'infinity' ? 'gradient text-white' : '']" block>Infinity</v-btn>
      <v-btn @click="onSelectChallenge('12_boucles')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '12_boucles' ? 'gradient text-white' : '']" block>12 boucles</v-btn>
      <v-btn @click="onSelectChallenge('6_boucles')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '6_boucles' ? 'gradient text-white' : '']" block>6 boucles</v-btn>
      <v-btn @click="onSelectChallenge('3_boucles')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '3_boucles' ? 'gradient text-white' : '']" block>3 boucles</v-btn>
      <v-btn @click="onSelectChallenge('2_boucles')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '2_boucles' ? 'gradient text-white' : '']" block>2 boucles</v-btn>
      <v-btn @click="onSelectChallenge('1_boucle')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '1_boucle' ? 'gradient text-white' : '']" block>1 boucle</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onSelectChallenge(challenge) {
      this.$store.commit("setSelectedLoop", 0);
      this.$store.commit("setSelectedChallenge", challenge);
      this.$router.push({ name: "ChallengeView", params: { challenge_uuid: challenge } });
    },
  },
};
</script>

<style lang="scss" scoped></style>